import { StyleSheet, I18nManager } from 'react-native'

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const isRTL = I18nManager.isRTL

export default StyleSheet.create({
  borderBottom: {
    borderBottomWidth: 1,
  },
  borderColor: {
    borderColor: Colors.veryLightPinkTwo,
  },
  container: {
  },
  contentContainer: {
    paddingTop: 0,
  },
  headdingContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  headingTouchable: {
    justifyContent: 'center',
    padding: 15,
    flexGrow: 1,
    flex: 1
  },
  touchableIcon: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: 15,
  },
  headdingText: {
    fontSize: 20,
    marginLeft: isRTL ? 0 : 17,
    marginRight: isRTL ? 17 : 0,
  },
  textWithIcon: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  iconSecondery: {
    tintColor: Colors.white,
  },
  opacityStyle: {
    opacity: 0.4,
  },
  extraListContainer: {
    margin: 16,
    marginRight: 0,
  },
  titleContainer: {
    //height: 48,
    justifyContent: 'center',
  },
})
